module.exports = __webpack_public_path__ + "img/flying mysterious shrine maiden.92c9cb94.png";